import type { TravelAgency } from '../types/travelAgencyMaintenance';

export const mockTravelAgencies: TravelAgency[] = [
  {
    id: '1',
    taCode: 'A0202781',
    taName: 'ALAN TAN CHU',
    isActive: true,
    createdAt: new Date('2024-01-15'),
    lastModified: new Date('2025-01-16')
  },
  {
    id: '2',
    taCode: 'A2611054',
    taName: 'ANTONIO C. MENDOZA',
    isActive: true,
    createdAt: new Date('2024-02-10'),
    lastModified: new Date('2025-01-15')
  },
  {
    id: '3',
    taCode: 'V3M22745',
    taName: 'CORAZON GLORIA G. MANOSCA',
    isActive: true,
    createdAt: new Date('2024-03-05'),
    lastModified: new Date('2025-01-14')
  },
  {
    id: '4',
    taCode: 'A0202881',
    taName: 'EDGAR C. BARTOLATA',
    isActive: true,
    createdAt: new Date('2024-04-20'),
    lastModified: new Date('2025-01-16')
  },
  {
    id: '5',
    taCode: 'A0209011',
    taName: 'FERDINAND R. GALGANA',
    isActive: false,
    createdAt: new Date('2024-05-12'),
    lastModified: new Date('2024-12-20')
  },
  {
    id: '6',
    taCode: 'V4U22874',
    taName: 'JP BUENCAMINO INSURANCE SERVICES',
    isActive: true,
    createdAt: new Date('2024-06-01'),
    lastModified: new Date('2025-01-13')
  },
  {
    id: '7',
    taCode: 'A0203259',
    taName: 'KPI INSURANCE AGENCY CORP',
    isActive: true,
    createdAt: new Date('2024-07-08'),
    lastModified: new Date('2025-01-12')
  },
  {
    id: '8',
    taCode: 'A018108',
    taName: 'LEA PLATON',
    isActive: true,
    createdAt: new Date('2024-08-15'),
    lastModified: new Date('2025-01-11')
  },
  {
    id: '9',
    taCode: 'M4H22671',
    taName: 'NORTHLINK FUTURE INSURANCE AGENCY',
    isActive: true,
    createdAt: new Date('2024-09-22'),
    lastModified: new Date('2025-01-10')
  },
  {
    id: '10',
    taCode: 'A2Y11809',
    taName: 'PAUL NINO LEYRAN MEIM',
    isActive: true,
    createdAt: new Date('2024-10-30'),
    lastModified: new Date('2025-01-09')
  }
];